/**
 * Configuration file for the TTU Semester Cost Calculator
 * Contains all the pricing and fee information used in calculations
 */

const config = {
  // Base cost per credit hour
  credit_price: 650,

  // Cost for each TSI (Texas Success Initiative) course
  tsi_course_cost: 1000,

  // Fixed insurance fee per semester
  insurance: 50,

  // Fixed student services fee per semester
  student_services: 200,

  // Educational tax rate (2%)
  tax_edu: 0.02,

  // Services tax rate (13%)
  tax_iva: 0.13,

  // Number of installments for deferred payment
  deffered_payments: 4
};

export default config; 